export default () => ({
  hasInactiveContextLock: false
});
